// Copyright (C) 2017-2022 Smart code 203358507

const Slider = require('./Slider');

module.exports = Slider;
